import Common from '../../../Common';

export interface UserOauthAccessToken {
	client_id: string
	expires: string
	added: string
	request_ip: string
	request_user_agent: string
	locationId:	id
	locationCity: string | null
	locationCountry: string | null
}

const AccessToken = class extends Common {
	browse = (userId: id): CustomResponseBrowse<{ sessions: UserOauthAccessToken[] }> =>
		this.get(`/user/${userId}/oauth/access-token`)
}

export default AccessToken;
